export default __webpack_public_path__ + "static/media/logout-icon.7e8ada1b.svg";